<template>
    <div>
        <a-tag>{{ $t("chatbotv2.tag") }} 1</a-tag>
        <a-tag><a href="https://github.com/vueComponent/ant-design">{{ $t("chatbotv2.link") }}</a></a-tag>
        <a-tag closable @close="log">{{ $t("chatbotv2.tag") }} 2</a-tag>
        <a-tag closable @close.prevent>{{ $t("chatbotv2.preventDefault") }}</a-tag>
    </div>
</template>
<script>
export default {
    name: "SynonymItem",
    props: ["data"],
};
</script>
<style lang="scss"></style>
